module.exports = __webpack_public_path__ + "assets/img/stars_sm.d6482e8d.png";